export default __webpack_public_path__ + "static/media/AvataAccount.e13cd264.svg";